import { VariableSortOption } from '@rematter/frontend-lib-api-client';

import { VariableRecord } from '../types/pricing';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export const variablesListQueryAtom = createQueryAtomFactory(
  'brokerage.variablesList',
  (params: {
    ids?: string[];
    searchTerm?: string;
    limit?: number;
    offset?: number;
    sorting?: VariableSortOption[];
  }) => ({
    variables: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
        },
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 50,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        name: true,
        description: true,
        value: true,
        updatedByUser: {
          id: true,
          firstName: true,
          lastName: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data): { variables: VariableRecord[]; totalCount: number } => {
      if (!data?.variables?.entries) {
        return { variables: [], totalCount: 0 };
      }

      return {
        variables: data.variables.entries.map((v) => ({
          id: v.id,
          name: v.name,
          description: v.description ?? null,
          value: v.value != null ? Number(v.value) : null,
          updatedByUser: v.updatedByUser
            ? {
                id: v.updatedByUser.id,
                name: `${v.updatedByUser.firstName} ${v.updatedByUser.lastName}`.trim(),
              }
            : null,
          timestamps: {
            createdAt: parseZonedDateTime(v.timestamps.createdAt),
            updatedAt: parseZonedDateTime(v.timestamps.updatedAt),
          },
        })),
        totalCount: data.variables.page?.total ?? 0,
      };
    },
  },
);
